import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { RootState } from '../app/store';
import { fetchMe, setToken } from '../features/me/me';
import {
  PENDING_KEY, authorizeUrl, leaveForMicrosoft, newPendingSignIn, readPendingSignIn, readSignIn,
} from '../features/me/microsoftSignIn';
import { HOME } from '../home';

const Login = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [_, setCookie] = useCookies(['jolly']);
  const me = useAppSelector((state: RootState) => state.me);
  const [problem, setProblem] = useState<string | null>(null);

  // Back from Microsoft: the sign-in is in the address. It is read once,
  // then taken out of the address and forgotten, so it cannot be used again.
  useEffect(() => {
    const result = readSignIn(window.location.hash, readPendingSignIn());
    if (result === null) return;
    sessionStorage.removeItem(PENDING_KEY);
    window.history.replaceState(null, '', window.location.pathname);
    if ('error' in result) {
      setProblem(`The Microsoft sign-in did not complete: ${result.error}`);
      return;
    }
    dispatch(setToken(result.token));
    dispatch(fetchMe(result.token));
    setCookie('jolly', result.token, {
      path: '/',
      secure: true,
      sameSite: 'none',
    });
    navigate(HOME);
  }, []);

  const signIn = () => {
    const pending = newPendingSignIn();
    sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending));
    leaveForMicrosoft(authorizeUrl({ redirectUri: `${window.location.origin}/login`, ...pending }));
  };

  // A token the portal has just refused is not tried again by itself: that
  // was the spinner that never ended.
  const refused = me.status === 'failed' && !!me.value.token;
  const message = problem
    ?? (refused ? 'That sign-in was not accepted by the portal. Please sign in again.' : null);

  return (
    <div style={{ flexGrow: '1' }}>
      <Box flex={1} sx={{ width: '100%' }}>
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={4} sx={{ mt: 6 }}>
            <img width={280} src="/pineapple-logo.png" alt="Pineapple Net" />
          </Grid>
          <Grid item xs={4}>
            <h2>
              Admin Portal
            </h2>
          </Grid>
          <Grid item xs={4} alignContent="center" />
          <Grid item xs={4} alignContent="center">
            <Button variant="contained" size="large" onClick={signIn}>
              Sign in with Microsoft
            </Button>
          </Grid>
          {message && (
            <Grid item>
              <Alert severity="warning" role="alert">{message}</Alert>
            </Grid>
          )}
          <Grid item>
            ©
            {' '}
            {new Date().getFullYear()}
            {' '}
            Pineapple Net
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Login;
